globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.LocationCreation = (function(superClass) {

  utils.extend(LocationCreation, superClass);

  function LocationCreation() {
    return LocationCreation.__super__.constructor.apply(this, arguments);
  }

  $.extend(LocationCreation.prototype, {
    init: function() {
      var _this = this;
      this.$html.find('[data-role="google-maps-address-section"]').each(function() {
        _this._initAddressSection($(this));
      });
      this._initNestedLocationToggle();
      return LocationCreation.__super__.init.apply(this, arguments);
    },

    _initAddressSection: function($section) {
      if ($section.data('address-initialized')) return;
      $section.data('address-initialized', true);

      var $inputGeocoder = $section.find('[data-role="find-address-input"]'),
          $btnChangeAddress = $section.find('.btn-change-address'),
          $map = $section.find('[data-role="address-map"]'),
          $summary = $section.find('[data-role="address-summary"]');

      if (!$inputGeocoder.length) return;

      var setGmapHeight = function() {
        if ($map.length && $summary.length) {
          $map.css('height', $summary[0].offsetHeight + 'px');
        }
      };

      setGmapHeight();

      $btnChangeAddress.on('click', function() {
        $btnChangeAddress.closest('.form-group').find('.edit-address-fields').toggle().find('input').first().focus();
      });

      $section.find('[data-role="address-line-2"]').on('change', function() {
        $section.find('[data-address-component="line_2"]').html($(this).val());
      });

      var fieldBy = function(role) { return $section.find('[data-role="' + role + '"]').first(); };

      $inputGeocoder.addresspicker({
        apiKey: helpers.google.api.key,
        elements: {
          map:          $map[0],
          lat:          fieldBy('address-latitude')[0],
          lng:          fieldBy('address-longitude')[0],
          postal_code:  fieldBy('address-postal-code')[0],
          locality:     fieldBy('address-city')[0],
          country:      fieldBy('address-country')[0],
          country_code: fieldBy('address-region-code')[0]
        },
        mapOptions: { zoom: 15 },
        draggableMarker: !$inputGeocoder.prop('disabled'),
        reverseGeocode: !$inputGeocoder.prop('disabled'),
        updateCallback: function(geocodeResult, parsedGeocodeResult) {
          var addressLine1 = [];
          if (parsedGeocodeResult.street_number) addressLine1.push(parsedGeocodeResult.street_number);
          if (parsedGeocodeResult.route) addressLine1.push(parsedGeocodeResult.route);

          fieldBy('address-line-1').val(addressLine1.join(' '));

          Object.keys(parsedGeocodeResult).forEach(function(key) {
            var $component = $section.find('[data-address-component=' + key + ']');
            if ($component.length) {
              $component.html(parsedGeocodeResult[key]);
            }
          });

          var instance = $inputGeocoder.data('ui-addresspicker');
          if (instance && instance.gmarker && geocodeResult.geometry) {
            instance.gmarker.setPosition(geocodeResult.geometry.location);
            instance.gmarker.setVisible(true);
            if (geocodeResult.geometry.viewport) {
              instance.gmap.fitBounds(geocodeResult.geometry.viewport);
            } else {
              instance.gmap.setCenter(geocodeResult.geometry.location);
            }
          }

          setGmapHeight();
        }
      });
    },

    _initNestedLocationToggle: function() {
      var $modal = this.$html,
          $checkbox = $modal.find('[data-role="toggle-nested-location"]');

      if (!$checkbox.length) return;

      var $wrapper = $modal.find('[data-role="nested-location-wrapper"]'),
          $orgName = $modal.find('[data-role="organisation-name"]'),
          $nestedName = $modal.find('[data-role="nested-location-name"]'),
          _this = this;

      $wrapper.toggle($checkbox.is(':checked'));

      $checkbox.on('change', function() {
        var checked = $(this).is(':checked');
        $wrapper.toggle(checked);

        if (checked && !$nestedName.val() && $orgName.val()) {
          $nestedName.val($orgName.val());
        }

        if (checked) {
          $wrapper.find('[data-role="google-maps-address-section"]').each(function() {
            _this._initAddressSection($(this));
          });
        }
      });
    },

    callbackSuccess: function(data) {
      if (!data) return;

      if (data.redirect_uri) {
        window.location.href = data.redirect_uri;
        return;
      }

      if (data.html) {
        this.updateView(data);
      }
    },

    updateView: function(response) {
      if (response && response.html) {
        this.$html.find('.modal-content').replaceWith($(response.html).find('.modal-content'));
        this.init();
      }
    }
  });

  return LocationCreation;

})(appCustomerSpace.Modal);
